import { render, staticRenderFns } from "./sms-journal-list.vue?vue&type=template&id=4b07e8ca&scoped=true"
import script from "./sms-journal-list.vue?vue&type=script&lang=js"
export * from "./sms-journal-list.vue?vue&type=script&lang=js"
import style0 from "./sms-journal-list.vue?vue&type=style&index=0&id=4b07e8ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b07e8ca",
  null
  
)

export default component.exports